class AdButlerClient {
	endpoint = window.location.protocol + '//servedbyadbutler.com/adserve/';
	zonePlacements = {};

	getAds(zoneId, language, format, labels = []) {
		return this.fetchAds('jsonr', zoneId, language, format, labels);
	}

	getAd(zoneId, language, format, labels = []) {
		return this.fetchAds('json', zoneId, language, format, labels);
		// return this.mockNoAds();
	}

	fetchAds(type, zoneId, language, format, labels) {
		if (!window.arenaParams.adButlerInstanceId) {
			console.error('Adbutler instance not configured');
			return [];
		}

		// Tbd. this should be sent along with pid parameter for unique delivery
		const currentPlacement = this.zonePlacements[zoneId] ? this.zonePlacements[zoneId] + 1 : 0;
		this.zonePlacements[zoneId] = currentPlacement;

		return this.post({
			ID:         window.arenaParams.adButlerInstanceId,
			setID:      zoneId,
			type:       type,
			rf:         1,
			kw:         labels,
			referrer:   window.location.href,
			ua:         window.navigator.userAgent,
			_abdk_json: {
				format:   format,
				language: language,
			},
		});
	}

	refreshAd(refreshUrl) {
		return fetch(refreshUrl,
			{
				method:      'GET',
				mode:        'cors',
				credentials: 'omit',
				headers:     {
					'Content-Type': 'application/json',
				},
			});
	}

	post(data) {
		return fetch(this.endpoint,
			{
				method:      'POST',
				body:        JSON.stringify(data),
				mode:        'cors',
				credentials: 'omit',
			});
	};

	getRelativeUrl(url) {
		return url.replace('https://servedbyadbutler.com/adserve/', '');
	}

	mockIframe() {
		const mockResponse = {
			status: 200,
			ok:     true,
			json:   () => Promise.resolve({
				status:     'SUCCESS',
				placements: {
					placement_1: {
						banner_id:             '521994663',
						width:                 '970',
						height:                '250',
						alt_text:              '',
						accompanied_html:      '',
						target:                '_blank',
						tracking_pixel:        '',
						body:                  '<iframe width=\'970\' height=\'250\' marginwidth=\'0\' marginheight=\'0\' hspace=\'0\' vspace=\'0\' frameborder=\'0\' scrolling=\'no\' src=\'http://servedbyadbutler.com/creative-183651-4204847/index.html?clickTag=http%3A%2F%2Fservedbyadbutler.com%2Fredirect.spark%3FMID%3D183651%26plid%3D2454405%26setID%3D597113%26channelID%3D21693%26CID%3D898577%26banID%3D521994663%26PID%3D0%26textadID%3D0%26tc%3D1%26rnd%3D7486063837%26scheduleID%3D2372962%26adSize%3D970x250%26data_keys%3D%257B%2522format%2522%253A%2522breaker_desktop%2522%252C%2522language%2522%253A%2522de-CH%2522%257D%26mt%3D1728371618885978%26spr%3D1%26hc%3Daecec30366dea4acf564fb5570cb7acedf429bb1%26location%3D&clicktag=http%3A%2F%2Fservedbyadbutler.com%2Fredirect.spark%3FMID%3D183651%26plid%3D2454405%26setID%3D597113%26channelID%3D21693%26CID%3D898577%26banID%3D521994663%26PID%3D0%26textadID%3D0%26tc%3D1%26rnd%3D7486063837%26scheduleID%3D2372962%26adSize%3D970x250%26data_keys%3D%257B%2522format%2522%253A%2522breaker_desktop%2522%252C%2522language%2522%253A%2522de-CH%2522%257D%26mt%3D1728371618885978%26spr%3D1%26hc%3Daecec30366dea4acf564fb5570cb7acedf429bb1%26location%3D&__ab_location=http%3A%2F%2Fservedbyadbutler.com%2Fredirect.spark%3FMID%3D183651%26plid%3D2454405%26setID%3D597113%26channelID%3D21693%26CID%3D898577%26banID%3D521994663%26PID%3D0%26textadID%3D0%26tc%3D1%26rnd%3D7486063837%26scheduleID%3D2372962%26adSize%3D970x250%26data_keys%3D%257B%2522format%2522%253A%2522breaker_desktop%2522%252C%2522language%2522%253A%2522de-CH%2522%257D%26mt%3D1728371618885978%26spr%3D1%26hc%3Daecec30366dea4acf564fb5570cb7acedf429bb1%26location%3D&__ab_zone_id=597113&__ab_zone_name=Zone%2013.03%20%7C%20Spalte%20Desktop%20%7C%20video.stv-fsg.ch&__ab_publisher_id=164506&__ab_publisher_name=13%20%7C%20video.stv-fsg.ch%20%7C%20Publisher&__ab_campaign_id=898577&__ab_campaign_name=2024%20%7C%20Coop%20Turnen%20%7C%20Campaign&__ab_advertiser_id=196161&__ab_advertiser_name=01%20%7C%20Coop%20%7C%20Advertiser&__ab_banner_id=521994663&__ab_extra_data=&spr=1\'></iframe>',
						redirect_url:          'http://servedbyadbutler.com/redirect.spark?MID=183651&plid=2454405&setID=597113&channelID=21693&CID=898577&banID=521994663&PID=0&textadID=0&tc=1&rnd=7486063837&scheduleID=2372962&adSize=970x250&data_keys=%7B%22format%22%3A%22breaker_desktop%22%2C%22language%22%3A%22de-CH%22%7D&mt=1728371618885978&spr=1&hc=aecec30366dea4acf564fb5570cb7acedf429bb1&location=',
						refresh_url:           'http://servedbyadbutler.com/adserve/;ID=183651;size=0x0;setID=597113;type=json;place=0;pid=;rct=1;rcb=1;rnd=97197',
						rct:                   '1',
						rcb:                   '1',
						refresh_time:          '60',
						placement_id:          '2454405',
						user_frequency_views:  '',
						user_frequency_start:  '',
						user_frequency_expiry: '',
						is_redirectable:       true,
						image_url:             'http://servedbyadbutler.com/getad.img/;libID=4204847',
					},
				},
				success: true,
			}),
		};
		return Promise.resolve(mockResponse);
	};

	mockNoAds() {
		const mockResponse = {
			status: 200,
			ok:     true,
			json:   () => Promise.resolve({
				status:     'NO_ADS',
				placements: {},
			}),
		};
		return Promise.resolve(mockResponse);
	};
};

export const adButlerClient = new AdButlerClient();
